import { render, staticRenderFns } from "./ProjectStatusCard.vue?vue&type=template&id=2ab3d0be&scoped=true"
import script from "./ProjectStatusCard.vue?vue&type=script&lang=js"
export * from "./ProjectStatusCard.vue?vue&type=script&lang=js"
import style0 from "./ProjectStatusCard.vue?vue&type=style&index=0&id=2ab3d0be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab3d0be",
  null
  
)

export default component.exports